/* eslint-disable react/prop-types */
import NavigationIcon from "@mui/icons-material/Navigation";
import Fab from "@mui/material/Fab";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

const ScrollToTopButton = ({ sxCustom = {} }) => {
  const fabStyle = {
    position: "fixed",
    bottom: "0.5rem",
    right: "0.75rem",
  };
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;
      if (scrolled > 50) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisible);
    return () => {
      window.removeEventListener("scroll", toggleVisible);
    };
  }, []);

  const scrollToTop = () => {
    window &&
      window.scrollTo({
        top: 0,
        behavior: "smooth",
        /* you can also use 'auto' behaviour
           in place of 'smooth' */
      });
  };

  return (
    // <Tooltip title="Về đầu trang" placement="top" arrow>
    <Fab
      sx={Object.keys(sxCustom).length === 0 ? fabStyle : sxCustom}
      size="small"
      color="primary"
      aria-label="add"
      onClick={scrollToTop}
      style={{ display: visible ? "inline" : "none" }}
    >
      <NavigationIcon />
    </Fab>
    // </Tooltip>
  );
};

ScrollToTopButton.propTypes = {
  sxCustom: PropTypes.any,
};

export default ScrollToTopButton;
